import React, { useState } from "react";
import { LeadViewAdditionalDetailsProps } from "./lead-view-additional-details.props";
import LeadViewDetailsView from "./lead-view-details-view/lead-view-details-view";
import LeadViewDetailsEdit from "./lead-view-details-edit/lead-view-details-edit";
import "./lead-view-additional-details.scss";

const LeadViewAdditionalDetails: React.FC<LeadViewAdditionalDetailsProps> = (
  props: any
) => {
  const {
    leadDetails,
    selectedLeadId,
    setLoading,
    viewEditOpen,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    uploadedImage,
    setUploadedImage,
    uploadedImageFile,
    setUploadedImageFile,
    setRemoveImage,
    removeImage,
    fetchLeadDetails,
    onLeadNameUpdate,
    resetImageUpload,
    handleFormSubmitError,
    permissions,
    isMobile,
  } = props;
  return (
    <div className="lead-list-view-details-edit-view">
      <div className="lead-list-view-details-view">
        <LeadViewDetailsView
          leadDetails={leadDetails}
          setLoading={setLoading}
          selectedLeadId={selectedLeadId}
          viewEditOpen={viewEditOpen}
          viewFullInfoOpen={viewFullInfoOpen}
          setViewFullInfoOpen={setViewFullInfoOpen}
          uploadedImage={uploadedImage}
          setUploadedImage={setUploadedImage}
          uploadedImageFile={uploadedImageFile}
          setUploadedImageFile={setUploadedImageFile}
          setRemoveImage={setRemoveImage}
          removeImage={removeImage}
          fetchLeadDetails={fetchLeadDetails}
          onLeadNameUpdate={onLeadNameUpdate}
          resetImageUpload={resetImageUpload}
          handleFormSubmitError={handleFormSubmitError}
          permissions={permissions}
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default LeadViewAdditionalDetails;
